module.exports = __webpack_public_path__ + "img/headpath.4599e645.png";